require('./jv.tracking.jobBoards.paramsFAC');

angular.module('jv.tracking.jobBoards.addCtrl', [
    'jv.tracking.jobBoards.paramsFAC'
    ])
    .controller('jobBoardAddCtrl', ['$scope','$location','commonControllerActionsFAC','jobBoardService','jobBoardDataDeserializeFAC','jobBoardDataValidationFAC','$rootScope',
        function ($scope, $location, commonControllerActionsFAC, jobBoardService, jobBoardDataDeserializeFAC, jobBoardDataValidationFAC, $rootScope){
            //import common actions like addNewVersion, redirectoList from commonControllerActionsFAC
            angular.extend($scope, commonControllerActionsFAC());
            $scope.pageTitle = 'Add Job Board';
            $rootScope.flags = $rootScope.flags || {};
            $rootScope.flags.loading = false;

            $scope.jobBoard = {
                paid: '-1',
                standardFormat: 'true',
                customFormat: 'false',
                enabled: false,
                versions: {
                    1: {
                        fileName: '',
                        sourceParameters: '',
                        lastUploadedFile: '',
                        connector:{
                            type: 'SFTP',
                            params:{
                                sftpHost: 'sftp.jobvite.com',
                                sftpDirectory:'/sftp/',
                                sftpPort: '12010'
                            }
                        },
                        notification:{}
                    }
                }
             };

            $scope.deleteNewVersion = function(versionNumber){
                delete $scope.jobBoard.versions[versionNumber];
            };

            $scope.save = function(){
                $scope.startValidation = true;
                if(jobBoardDataValidationFAC($scope.jobBoard)){
                    $rootScope.flags.loading = true;
                    var postData = jobBoardDataDeserializeFAC($scope.jobBoard);
                    jobBoardService.addNewJobBoard(postData, function(response){
                        if(response){
                            if(response.msgInfo === 200){
                                $location.path('/list/added');
                            }
                        }
                    }, function(){
                        $location.path('/list/opserror/true');
                    });
                }
            };
        }
    ]);